// extracted by mini-css-extract-plugin
export default {"home":"home_home__2AaT8"};